import { breakpoints } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled from "styled-components";
import { colors } from "../../../../utils/colors";

export const Outer = styled.div`
    .services-in-region{
        h2,
        h3{
            font-size: 25px;

            ${breakpoints.large} {
                font-size: 32px;
            }
        }
    }
`;

export const PageContainer = styled.div`
    background-color: ${colors.white};
    padding-bottom: 50px;
`;

export const CategorySections = styled.div`
    padding: 16px 0 0;
`;

export const CategorySection = styled.div`
    &:not(:last-child) {
        margin-bottom: 56px;

        ${breakpoints.large} {
            margin-bottom: 75px;
        }
    }
`;

export const CategorySectionTitle = styled.h3`
    margin-bottom: 0;
    text-align: center;
    flex-grow: 1;

    ${breakpoints.large} {
        font-size: 28px;
        text-align: left;
    }
`;

export const Buttons = styled.div`
    ${breakpoints.medium} {
        max-width: 275px;
        margin: 0 auto;
    }
`;

export const SecondaryResultsTitleContainer = styled.div`
    position: relative;
    z-index: 1;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    ${breakpoints.large} {
        margin-bottom: 30px;
    }
`;

export const RichTextStyleOverride = styled.div`
    margin-top: -16px;

    p {
        color: ${transparentize(0.5, colors.brandDark)};
    }
`;
